import { render } from "./Dot.vue?vue&type=template&id=3a779c0d"
import script from "./Dot.vue?vue&type=script&lang=ts"
export * from "./Dot.vue?vue&type=script&lang=ts"
script.render = render

export default script